import { render, staticRenderFns } from "./NavbarWorld.vue?vue&type=template&id=a11aceb0&scoped=true"
import script from "./NavbarWorld.vue?vue&type=script&lang=js"
export * from "./NavbarWorld.vue?vue&type=script&lang=js"
import style0 from "./NavbarWorld.vue?vue&type=style&index=0&id=a11aceb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11aceb0",
  null
  
)

export default component.exports